import CmonStats, { CmonStatsProps } from '../cmon/models/CmonStats';

export type CcStatsProps = CmonStatsProps & {};

export default class CcStats extends CmonStats {
    constructor(props: CcStatsProps) {
        super(props);
    }
}
